<template>
    <div>
        <div v-if="status == 0">
            Mengambil data barang, mohon menunggu...
        </div>
        <div v-else-if="status == -1">
            Gagal mengambil data barang.
        </div>
        <div v-else-if="status == 1">
            <h3 class="mb-0">{{ data.type }} <span v-if="data.year != null">({{ data.year }})</span></h3>
            {{ data.kind }} - {{ data.brand }}
            <b-row class="mt-2">
                <b-col md="4">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="4">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Grade</strong><br />
                    {{ data.grade }}
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="4">
                    <strong>Kelengkapan</strong><br />
                    {{ data.is_batangan ? "Batangan" : "Lengkap" }}
                </b-col>
                <b-col md="4">
                    <strong>Spek</strong><br />
                    {{ data.spec || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Gudang</strong><br />
                    {{ data.warehouse || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-4 mb-2">
                <b-col class="text-right">
                    <b-button variant="primary" @click="confirmAdd">
                        <i class="fa fa-check mr-2" />Lanjutkan
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <b-modal id="m-confirm" title="Konfirmasi" centered no-close-on-backdrop no-close-on-esc hide-footer>
            Konfirmasi {{ invoiceDetailId == null ? 'penambahan' : 'pengubahan' }} barang ini kedalam invoice pengembalian.
            <b-row class="mt-4">
                <b-col>
                    <strong>Barang</strong><br />
                    {{ data.type }} <span v-if="data.year != null">({{ data.year }})</span>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>No. Faktur</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="6">
                    <strong>IMEI / SN</strong><br />
                    {{ data.imei_sn || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Grade</strong><br />
                    {{ data.grade }}
                </b-col>
                <b-col md="6">
                    <strong>Spek</strong><br />
                    {{ data.spec || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <strong>Kelengkapan</strong><br />
                    {{ data.is_batangan ? "Batangan" : "Lengkap" }}
                </b-col>
                <b-col md="6">
                    <strong>Gudang</strong><br />
                    {{ data.warehouse || "-" }}
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execAddItem">
                    {{ isSubmitting ? "Menambahkan..." : "Tambahkan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        noFaktur: { type: String, required: true },
        returnInvoiceId: { type: Number, required: true }
    },
    data() {
        return {

            status: 0, // 0: loading, 1: success, -1: fail
            isSubmitting: false,

            data: {},

            items: []

        }
    },
    methods: {

        init() {

            this.status = 0
            let payload = {
                no_faktur_pgi: this.noFaktur,
                return_invoice_id: this.returnInvoiceId
            }

            if(this.invoiceDetailId != null) {
                payload.invoice_detail_id = this.invoiceDetailId
            }

            this.$axios.post("inventory-return-pgi/get-return-item", payload).then(res => {

                let data = res.data.data
                this.data = data

                this.status = 1

            })
            .catch(error => {

                this.$helper.parseError(this, error)
                this.status = -1

            })

        },

        confirmAdd() {

            this.$bvModal.show("m-confirm")

        },

        execAddItem() {

            let payload = {
                no_faktur_pgi: this.noFaktur,
                return_invoice_id: this.returnInvoiceId
            }

            this.isSubmitting = true
            this.$axios.post("inventory-return-pgi/add-item-return-invoice", payload).then(res => {

                this.$bvModal.hide("m-confirm")
                this.$emit("item-added", "Barang berhasil ditambahkan!")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    },
    created() {
        this.init()
    }
}
</script>
